// import { translate } from 'react-i18next';

export const maxValue = (max,{t}) => {
  return  t('validation-errormessages-maxvalue',{max:max});
}
export const minValue = (min,{t}) => {
  return  t('validation-errormessages-minvalue',{min:min});
}
